// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: var(--color-card-background);
  color: var(--color-card-text);
  border: none;
}
.card .brand-desc {
  font-weight: 600;
  font-size: 30px;
  line-height: 120%;
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
  margin: 0;
}
.card .policy-info {
  color: var(--color-primary);
  text-decoration: underline;
  margin: 5%;
}
.card .app-instruction {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  order: 2;
  margin: 24px 0px;
}

.steps .step .step-text {
  margin-left: 12px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  color: var(--color-card-text);
}
.steps .step .fa-circle {
  font-size: 14px;
  color: var(--color-primary);
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/landing-page/landing-page.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,8CAAA;EACA,6BAAA;EACA,YAAA;AACF;AAAE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;AAEJ;AAAE;EACE,2BAAA;EACA,0BAAA;EACA,UAAA;AAEJ;AAAE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,QAAA;EACA,gBAAA;AAEJ;;AAII;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AADN;AAGI;EACE,eAAA;EACA,2BAAA;EACA,mBAAA;AADN","sourcesContent":[".card {\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  background-color: var(--color-card-background);\n  color: var(--color-card-text);\n  border: none;\n  .brand-desc {\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 120%;\n    display: flex;\n    flex-direction: column;\n    padding: 16px 0px;\n    margin: 0;\n  }\n  .policy-info {\n    color: var(--color-primary);\n    text-decoration: underline;\n    margin: 5%;\n  }\n  .app-instruction {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 120%;\n    order: 2;\n    margin: 24px 0px;\n  }\n}\n\n.steps {\n  .step {\n    .step-text {\n      margin-left: 12px;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 16px;\n      line-height: 120%;\n      color: var(--color-card-text);\n    }\n    .fa-circle {\n      font-size: 14px;\n      color: var(--color-primary);\n      margin-bottom: 20px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
